// let gameStartTime = null;

// call when game is initiated
function handleStartGame(gameMode = 'standard') {
    // gameStartTime = Date.now();

    if (typeof gtag === 'function') {
    gtag('event', 'game_start', {
        'game_mode': gameMode
    });
    }
}

// call when game ends
function handleFinishGame(score = 0) {
    // Calculate elapsed seconds from gameStartTime
    // const durationSeconds = gameStartTime 
    // ? Math.round((Date.now() - gameStartTime) / 1000) 
    // : 0;

    if (typeof gtag === 'function') {
    gtag('event', 'game_finish', {
        'score': Number(score),
        // 'duration_seconds': durationSeconds
    });
    }
}

// call when sharing
function handleShareClick(platformName) {
    if (typeof gtag === 'function') {
        gtag('event', 'share', {
            'method': platformName,
            'content_type': 'game_score'
        });
    }
}

// call when user copies
function handleCopyClick(platformName) {
    if (typeof gtag === 'function') {
        gtag('event', 'copy_share_results', {
            'method': platformName,
            'content_type': 'game_score'
        });
    }
}

// when user clicks stats
function handleStatsModalClick(source = 'navigation_button') {
  if (typeof gtag === 'function') {
    console.log(source)
    window.gtag('event', 'view_stats', {
      'source': source
    });
  }
}

// when user clicks how to play
function handleHowToPlayModalClick(source = 'navigation_button') {
  if (typeof gtag === 'function') {
    console.log(source)
    window.gtag('event', 'view_how_to_play', {
      'source': source
    });
  }
}

export {handleStartGame, handleFinishGame, handleShareClick, handleCopyClick, handleStatsModalClick, handleHowToPlayModalClick}